import { render, staticRenderFns } from "./vueTypeahead.vue?vue&type=template&id=1007440c"
import script from "./vueTypeahead.vue?vue&type=script&lang=js"
export * from "./vueTypeahead.vue?vue&type=script&lang=js"
import style0 from "./vueTypeahead.vue?vue&type=style&index=0&id=1007440c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports